/**
 * The faces of the ink-wash windows (ui/panels-ink.css): Noto Serif Thai for their headings and
 * text, Noto Serif TC 500 for the vertical caption, and Ma Shan Zheng for the brush-written heading
 * glyph. The Han faces are subset to exactly UI_GLYPHS. Started at boot and awaited before the world
 * shows (main.ts), behind the loading scene, so no window ever swaps its font in front of the player.
 */
import { UI_GLYPHS } from '@nine/shared';

/** How long to wait for the faces before going on with the fallbacks (a slow or blocked font host). */
const STALL_MS = 8000;

const css = (query: string): HTMLLinkElement => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${query}&display=block`;
  document.head.append(link);
  return link;
};

const sheet = (link: HTMLLinkElement) =>
  new Promise<void>((ok) => {
    link.addEventListener('load', () => ok(), { once: true });
    link.addEventListener('error', () => ok(), { once: true });
  });

/** Loads the windows' faces; resolves when they are ready, or after a stall, never rejects. */
export function loadInkFonts(): Promise<void> {
  const thai = css('family=Noto+Serif+Thai:wght@400;600;700');
  const han = css(`family=Noto+Serif+TC:wght@500&family=Ma+Shan+Zheng&text=${encodeURIComponent(UI_GLYPHS)}`);
  const work = (async () => {
    await Promise.all([sheet(thai), sheet(han)]);
    await Promise.allSettled([
      document.fonts.load('400 14px "Noto Serif Thai"', 'กขฃคง'),
      document.fonts.load('600 14px "Noto Serif Thai"', 'กขฃคง'),
      document.fonts.load('700 18px "Noto Serif Thai"', 'กขฃคง'),
      document.fonts.load('500 17px "Noto Serif TC"', '九劍無敵'),
      document.fonts.load('400 44px "Ma Shan Zheng"', '武'),
    ]);
  })();
  return Promise.race([work, new Promise<void>((ok) => setTimeout(ok, STALL_MS))]);
}
